var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import moment from 'moment';
import { ELSLoggingService } from '@els/els-ui-common-react';
import { APP_LINK_BACK_TITLE_BY_APP_NAME, APP_LINK_PAGE_NAME_WITH_ROUTE, EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { CS_APP_NAME, EAB_APP_NAME, PageNamePrefixes } from 'constants/app.constant';
import { isCSAppByCourseSection, isEABAppByCourseSection } from 'reports/cw/services/courses.service';
import { getNewTokenForCourseSwitcher, fetchSessionDataFromExternalApp } from 'services/app-linking.service';
import { getDateRangeFromFilterOption } from 'reports/hesi-ng/helpers';
import { FILTER_OPTIONS_EXAM_DATE_RANGE, FILTER_OPTIONS_PARAM_FOR_HESI } from 'reports/hesi-ng/constants';
export var getTokenSwitchCourse = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var tokenBody, _c, data;
    var courseId = _b.courseId, userId = _b.userId, sessionId = _b.sessionId, appId = _b.appId, isbns = _b.isbns;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                tokenBody = {
                    userId: userId,
                    courseId: courseId,
                    sessionId: sessionId,
                    appParams: {
                        appId: appId,
                        isbns: isbns,
                        authorizedIsbns: isbns
                    }
                };
                return [4 /*yield*/, getNewTokenForCourseSwitcher(tokenBody)];
            case 1:
                _c = (_d.sent()).data, data = _c === void 0 ? { token: '' } : _c;
                return [2 /*return*/, data.token];
        }
    });
}); };
// Resolve the ORIGINAL launching app from the root app-link, which is preserved as keptXLinkId
// across Performance -> other app -> Performance round trips. Falls back to undefined so callers
// keep the current last-visited behavior when there is no root link or the lookup fails.
// Walks the keptXLinkId chain recursively: a page reached via an intermediate round trip points
// keptXLinkId one hop shallow (to a Performance-sourced link), so when a link resolves to
// Performance we descend into its own keptXLinkId until we hit a real source app, run out of links,
// or a lookup fails. `seen` guards against a cyclic chain.
var walkOriginSrcApp = function (keptXLinkId, seen) { return __awaiter(void 0, void 0, Promise, function () {
    var PERFORMANCE, rootSessionData, rootSrcApp;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                PERFORMANCE = EXTERNAL_APP_INFO.APP_LINKING.PERFORMANCE;
                if (!keptXLinkId || seen.has(keptXLinkId)) {
                    return [2 /*return*/, undefined];
                }
                seen.add(keptXLinkId);
                return [4 /*yield*/, fetchSessionDataFromExternalApp(keptXLinkId).catch(function (error) {
                        ELSLoggingService.warn('resolveOriginSrcApp', "Failed to resolve root srcApp for keptXLinkId: ".concat(error === null || error === void 0 ? void 0 : error.message));
                        return null;
                    })];
            case 1:
                rootSessionData = _d.sent();
                rootSrcApp = (_a = rootSessionData === null || rootSessionData === void 0 ? void 0 : rootSessionData.data) === null || _a === void 0 ? void 0 : _a.srcApp;
                if (rootSrcApp && rootSrcApp !== PERFORMANCE.APP_NAME) {
                    return [2 /*return*/, rootSrcApp];
                }
                return [2 /*return*/, walkOriginSrcApp((_c = (_b = rootSessionData === null || rootSessionData === void 0 ? void 0 : rootSessionData.data) === null || _b === void 0 ? void 0 : _b.outPostBody) === null || _c === void 0 ? void 0 : _c.keptXLinkId, seen)];
        }
    });
}); };
export var resolveOriginSrcApp = function (outPostBody, currentSrcApp) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        if (currentSrcApp !== EXTERNAL_APP_INFO.APP_LINKING.PERFORMANCE.APP_NAME) {
            return [2 /*return*/, undefined];
        }
        return [2 /*return*/, walkOriginSrcApp(outPostBody === null || outPostBody === void 0 ? void 0 : outPostBody.keptXLinkId, new Set())];
    });
}); };
export var getBreadcrumbBackTitle = function (_a) {
    var performanceReportPage = _a.performanceReportPage, srcApp = _a.srcApp, targetApp = _a.targetApp, courseSection = _a.courseSection, originSrcApp = _a.originSrcApp, keptTargetApp = _a.keptTargetApp;
    var REPORTING_PORTAL = APP_LINK_PAGE_NAME_WITH_ROUTE.REPORTING_PORTAL, PS_DASHBOARD = APP_LINK_PAGE_NAME_WITH_ROUTE.PS_DASHBOARD, CPRA_DASHBOARD = APP_LINK_PAGE_NAME_WITH_ROUTE.CPRA_DASHBOARD, CPRA_STUDENT_DETAILS = APP_LINK_PAGE_NAME_WITH_ROUTE.CPRA_STUDENT_DETAILS;
    var _b = EXTERNAL_APP_INFO.APP_LINKING, SHERPATH = _b.SHERPATH, SHER_EVOL = _b.SHER_EVOL, PERFORMANCE = _b.PERFORMANCE;
    if (performanceReportPage === REPORTING_PORTAL.name) {
        return PageNamePrefixes.erp;
    }
    if (performanceReportPage === PS_DASHBOARD.name) {
        return PageNamePrefixes.ps;
    }
    if (performanceReportPage === CPRA_DASHBOARD.name || performanceReportPage === CPRA_STUDENT_DETAILS.name) {
        return PageNamePrefixes.hesi;
    }
    // The back button represents the ORIGINAL launching app. Across a round trip that origin is
    // preserved via the root app-link (originSrcApp); otherwise fall back to the last-visited app —
    // targetApp on a normal return, or keptTargetApp when the return session carries no src/target
    // (e.g. a new-tab launch that then visited another dashboard).
    var lastVisitedApp = originSrcApp || (srcApp === PERFORMANCE.APP_NAME || !srcApp ? targetApp || keptTargetApp : srcApp);
    // Sherpath-family apps resolve to EAB / Clinical Skills based on the course section.
    if (lastVisitedApp === SHERPATH.APP_NAME || lastVisitedApp === SHER_EVOL.APP_NAME) {
        if (isEABAppByCourseSection(courseSection)) {
            return EAB_APP_NAME;
        }
        if (isCSAppByCourseSection(courseSection)) {
            return CS_APP_NAME;
        }
    }
    return (lastVisitedApp && APP_LINK_BACK_TITLE_BY_APP_NAME[lastVisitedApp]) || '';
};
export var getSelectedExamGroups = function (examGroupId, examGroupIds) {
    var ALL_GROUPS = FILTER_OPTIONS_PARAM_FOR_HESI.ALL_GROUPS, MULTIPLE_GROUPS = FILTER_OPTIONS_PARAM_FOR_HESI.MULTIPLE_GROUPS;
    if (typeof examGroupId === 'string') {
        if (examGroupId === ALL_GROUPS) {
            return [];
        }
        if (examGroupId === MULTIPLE_GROUPS) {
            return examGroupIds === null || examGroupIds === void 0 ? void 0 : examGroupIds.map(function (egi) { return egi.toString(); });
        }
        return [examGroupId];
    }
    if (typeof examGroupId === 'number') {
        return [examGroupId === null || examGroupId === void 0 ? void 0 : examGroupId.toString()];
    }
    return [];
};
export var getFilterFromHesiApp = function (_a) {
    var examTypeId = _a.examTypeId, examGroupId = _a.examGroupId, examGroupIds = _a.examGroupIds, studentId = _a.studentId;
    var selectedExamGroups = getSelectedExamGroups(examGroupId, examGroupIds);
    return {
        examType: examTypeId,
        examGroups: selectedExamGroups,
        setParamsFromHesiApp: true,
        studentId: studentId
    };
};
export var getDateFilterFromHesiApp = function (_a) {
    var selectedDate = _a.selectedDate, examEndDate = _a.examEndDate, examStartDate = _a.examStartDate;
    var selectedStartDate;
    var selectedEndDate;
    var selectedDateRange = selectedDate;
    var CHOOSE_SPECIFIC_DATE_RANGE = FILTER_OPTIONS_PARAM_FOR_HESI.CHOOSE_SPECIFIC_DATE_RANGE;
    var chooseSpecificDateRange = FILTER_OPTIONS_EXAM_DATE_RANGE.chooseSpecificDateRange, lastThreeMonths = FILTER_OPTIONS_EXAM_DATE_RANGE.lastThreeMonths;
    if (typeof selectedDate === 'string') {
        if (selectedDate === CHOOSE_SPECIFIC_DATE_RANGE) {
            selectedStartDate = moment(examStartDate).valueOf();
            selectedEndDate = moment(examEndDate).valueOf();
        }
        else {
            var _b = getDateRangeFromFilterOption(selectedDate), fromDateUnix = _b.fromDateUnix, toDateUnix = _b.toDateUnix;
            selectedStartDate = fromDateUnix;
            selectedEndDate = toDateUnix;
        }
    }
    else if (examStartDate && !examEndDate) {
        selectedDateRange = chooseSpecificDateRange;
        selectedStartDate = moment(examStartDate).valueOf();
        selectedEndDate = moment().valueOf();
    }
    else {
        var _c = getDateRangeFromFilterOption(lastThreeMonths), fromDateUnix = _c.fromDateUnix, toDateUnix = _c.toDateUnix;
        selectedStartDate = fromDateUnix;
        selectedEndDate = toDateUnix;
    }
    return {
        selectedDate: selectedDateRange,
        fromDate: selectedStartDate,
        toDate: selectedEndDate
    };
};
export var getEAQStudentStudyReportLinkConfig = function (isStudentStudyEnabled) {
    if (isStudentStudyEnabled) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.STUDENT_STUDY.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.STUDENT_STUDY.ACTION.PERFORMANCE_VIEW
        };
    }
    return {
        appName: EXTERNAL_APP_INFO.APP_LINKING.EAQ.APP_NAME,
        action: EXTERNAL_APP_INFO.APP_LINKING.EAQ.ACTION.PERFORMANCE_VIEW
    };
};
